import { useRecoilState } from "recoil";
import { tokenApp } from "../atom";

const useTokenAppState = () => {
    return useRecoilState(tokenApp);
};

export default useTokenAppState;